import { Component, OnInit, Input, Output, EventEmitter, HostListener } from '@angular/core';
import { AlternativeCoveredDrugs } from '../../medication.interface';
import { SearchObjectService, SearchObject } from 'src/app/shared/services/search-object.service';
import { Router, NavigationEnd } from '@angular/router';

@Component({
  selector: 'app-alternate-medication-table',
  templateUrl: './alternate-medication-table.component.html',
  styleUrls: ['./alternate-medication-table.component.scss']
})
export class AlternateMedicationTableComponent implements OnInit {
  @Input() alternativeCoveredDrugs: AlternativeCoveredDrugs[] = [];
  @Output() onClickAlternateDrug: EventEmitter<AlternativeCoveredDrugs> = new EventEmitter();
  showNumberOfRecords: number = 4;
  isMobile: boolean = false;
  searchObject: SearchObject;
  navigationSubscription;
  isFormularyIdCheck: boolean = false;
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.isMobile = window.screen.width <= 1024;
  }
  constructor(private router: Router,
    private searchObjectService: SearchObjectService) {
    this.navigationSubscription = this.router.events.subscribe((e: any) => {
      // If it is a NavigationEnd event re-initalise the component
      if (e instanceof NavigationEnd) {
        this.searchObject = this.searchObjectService.getSearchObject();
        this.isFormularyIdCheck = this.searchObjectService.isFormularyIdCheck();
      }
    });
  }

  ngOnInit(): void {
    this.isMobile = window.screen.width <= 1024;
    this.searchObject = this.searchObjectService.getSearchObject();
    this.isFormularyIdCheck = this.searchObjectService.isFormularyIdCheck();
  }

  viewMoreAlternateMedications() {
    if (this.showNumberOfRecords === 4) {
      this.showNumberOfRecords = this.alternativeCoveredDrugs.length;
    } else {
      this.showNumberOfRecords = 4;
    }
  }

  onClickAlternateDrugEvent(drug: AlternativeCoveredDrugs) {
    this.onClickAlternateDrug.emit(drug);
  }

  getTextForCovered(isCovered : boolean) {
    return this.isFormularyIdCheck ? (isCovered ? 'Preferred' : 'Non-preferred') : (isCovered ? 'Covered' : 'Not Covered');
  }

  isShowBrandOrGeneric() : boolean {
    return !['0000010000010001700004', '0000010000010001700005', '0000010000010001700007', '0000010000010001700006', '0000010000010001700003', '0000010000010001700001', '0000010000010001700002', '0000010000010001700008'].includes(this.searchObject.networkId);
  }

  isShowTier(): boolean {
    return !['0000010000010001700006', '0000010000010001700007', '0000010000010001700003', '0000010000010001700005'].includes(this.searchObject.networkId);
  }

  ngOnDestroy() {
    if (this.navigationSubscription) {
      this.navigationSubscription.unsubscribe();
    }
  }

}
